import { FC, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { map } from 'rxjs/operators';

import type { StringFileResponse } from '../../../../models/FileResponse';
import { logAnalytics } from '../../../../shared/middlewares/analytics/logger';
import { downloadCsv } from '../../../../utils/documents/downloadDocument';
import { BlotterErrorIcon } from '../../BlotterErrorIcon';
import { BlotterSpinner } from '../../BlotterSpinner';
import { ExportCsv } from '../../Filter/ExportCsv';
import type { OwnProps, StateProps } from './Tools.connect';
import { connectSecondaryMarketOrderBlotterFilter } from './Tools.connect';

export type FilterProps = OwnProps & StateProps;

export const Tools: FC<FilterProps> = ({ fetchCsv, error, isLoading }) => {
  const { formatMessage } = useIntl();
  const fetch = useCallback(() => {
    return fetchCsv().pipe(
      map((response: StringFileResponse) => {
        logAnalytics.trackEvent('Blotter Secondary Market orders', 'Download CSV');
        downloadCsv(response.data, response.filename);
      }),
    );
  }, [fetchCsv]);

  return (
    <div className="d-flex flex-row w-100">
      <div className="d-flex flex-grow-1 px-16px align-items-center">
        <h5 className="lh-1">
          <FormattedMessage id="secondaryMarket.orderBlotter.title" />
        </h5>
        {error && <BlotterErrorIcon message={formatMessage({ id: 'blotter.filter.label.error' })} />}
        <BlotterSpinner className="flex-shrink-0 ms-2" hide={!isLoading} />
      </div>
      <ExportCsv fetch={fetch} />
    </div>
  );
};

export const SecondaryMarketOrderBlotterTools = connectSecondaryMarketOrderBlotterFilter(Tools);
